<template>
  <v-container
    fluid
    class="pa-0 ma-0"
    style="height: 80vh; display: flex; flex-direction: column;"
  >
    <div class="pedido-body">
      <div class="pedido-sidebar">
        <div class="pedido-sidebar__search">
          <v-text-field
            v-model="busca"
            dense
            outlined
            hide-details
            placeholder="Buscar pedido, cliente..."
            prepend-inner-icon="mdi-magnify"
            class="pedido-sidebar__input"
          />
        </div>

        <div
          v-if="carregando"
          class="pedido-sidebar__loading"
        >
          <v-icon
            class="pedido-spinner mr-2"
            :style="{ color: corPrimaria }"
          >
            mdi-cached
          </v-icon>
          Carregando...
        </div>

        <div class="pedido-sidebar__lista">
          <div
            v-for="pedido in pedidosFiltrados"
            :key="pedido.numpedido + '-' + pedido.nomeBd"
            class="pedido-card"
            :class="{ 'pedido-card--selecionado': pedidoSelecionado && pedidoSelecionado.numpedido === pedido.numpedido && pedidoSelecionado.nomeBd === pedido.nomeBd }"
            @click="selecionarPedido(pedido)"
          >
            <div
              class="pedido-card__avatar"
              :style="{ background: getAvatarBg(pedido), color: getStatusColor(pedido.status) }"
            >
              {{ getIniciais(pedido.cliente) }}
            </div>
            <div class="pedido-card__info">
              <div class="pedido-card__nome">
                {{ pedido.cliente }}
              </div>
              <div class="pedido-card__sub">
                Pedido {{ pedido.numpedido }} · {{ pedido.representante }}
              </div>
              <div class="pedido-card__data">
                {{ pedido.periodo }}
              </div>
            </div>
            <div
              class="pedido-card__dot"
              :style="{ background: getStatusColor(pedido.status) }"
            />
          </div>

          <div
            v-if="!carregando && pedidosFiltrados.length === 0"
            class="pedido-sidebar__vazio"
          >
            Nenhum pedido para o período selecionado.
          </div>
        </div>
      </div>

      <div class="pedido-area">
        <div
          id="mapPedidos"
          class="pedido-canvas"
        />

        <transition name="slide-up">
          <div
            v-if="pedidoSelecionado"
            class="pedido-detalhe-card"
          >
            <div class="pedido-detalhe-card__header">
              <div
                class="pedido-card__avatar pedido-detalhe-card__avatar"
                :style="{ background: getAvatarBg(pedidoSelecionado), color: getStatusColor(pedidoSelecionado.status) }"
              >
                {{ getIniciais(pedidoSelecionado.cliente) }}
              </div>
              <div class="pedido-detalhe-card__titulo">
                <div class="pedido-detalhe-card__nome">
                  {{ pedidoSelecionado.cliente }}
                </div>
                <div class="pedido-detalhe-card__sub">
                  Pedido {{ pedidoSelecionado.numpedido }}
                </div>
              </div>
              <v-btn
                icon
                x-small
                class="ml-auto"
                @click="fecharDetalhe"
              >
                <v-icon small>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>

            <div
              v-if="carregandoLocalizacao"
              class="pedido-detalhe-card__loading"
            >
              <v-progress-circular
                indeterminate
                size="18"
                width="2"
                class="mr-2"
              />
              Buscando localização...
            </div>

            <div
              v-else
              class="pedido-detalhe-card__body"
            >
              <div class="pedido-detalhe-row">
                <span class="pedido-detalhe-row__label">Status</span>
                <span class="pedido-detalhe-row__val">{{ pedidoSelecionado.status }}</span>
              </div>
              <div class="pedido-detalhe-row">
                <span class="pedido-detalhe-row__label">Vendedor</span>
                <span class="pedido-detalhe-row__val">{{ pedidoSelecionado.representante }}</span>
              </div>
              <div class="pedido-detalhe-row">
                <span class="pedido-detalhe-row__label">Valor</span>
                <span class="pedido-detalhe-row__val">{{ formatarValor(pedidoSelecionado.valor) }}</span>
              </div>
              <div
                v-if="localizacaoAtual"
                class="pedido-detalhe-row"
              >
                <span class="pedido-detalhe-row__label">Endereço cliente</span>
                <span class="pedido-detalhe-row__val">{{ localizacaoAtual.endereco }}</span>
              </div>
              <div
                v-if="!localizacaoAtual"
                class="pedido-detalhe-row"
              >
                <span class="pedido-detalhe-row__val pedido-detalhe-row__val--aviso">
                  Localização não disponível para este pedido.
                </span>
              </div>
              <div class="pedido-detalhe-row pedido-detalhe-row--destaque">
                <span class="pedido-detalhe-row__label">Data</span>
                <span class="pedido-detalhe-row__val">{{ pedidoSelecionado.periodo }}</span>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Pedidos from '../../../../services/pedidos'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'TablePedidos',

    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data () {
      return {
        corPrimaria: localStorage.corPrimaria || '#1976D2',
        pedidos: [],
        pedidoSelecionado: null,
        localizacaoAtual: null,
        busca: '',
        carregando: false,
        carregandoLocalizacao: false,
        map: null,
        marker: null,
        filtrosAtuais: null,

        snackbar: {
          visible: false,
          color: 'success',
          message: '',
          timeout: 3000,
        },
      }
    },

    computed: {
      pedidosFiltrados () {
        if (!this.busca) return this.pedidos

        const termo = this.busca.toLowerCase()
        return this.pedidos.filter(p =>
          (p.cliente && p.cliente.toLowerCase().includes(termo)) ||
          (p.representante && p.representante.toLowerCase().includes(termo)) ||
          String(p.numpedido).toLowerCase().includes(termo),
        )
      },
    },

    mounted () {
      if (!localStorage.tokencontrato) {
        localStorage.removeItem('username')
        this.$router.push('/login')
        return
      }

      eventEmit.$on('update-pedidos', this.handleUpdatePedidos)

      this.iniciarMapa()
    },

    beforeDestroy () {
      eventEmit.$off('update-pedidos', this.handleUpdatePedidos)
    },

    methods: {
      async iniciarMapa () {
        await this.$nextTick()

        const center = { lat: -20.7523, lng: -42.8733 }

        this.map = new window.google.maps.Map(document.getElementById('mapPedidos'), {
          center,
          zoom: 12,
          mapId: '6ae34073275a94e4',
          zoomControl: true,
          streetViewControl: true,
          mapTypeControl: false,
          fullscreenControl: true,
        })
      },

      handleUpdatePedidos (primeiroDia, dataFinal, select, receita, rede, categoria, promotor, vendedor) {
        this.filtrosAtuais = { primeiroDia, dataFinal, select, receita, rede, categoria, promotor, vendedor }
        this.buscarPedidos()
      },

      async buscarPedidos () {
        if (!this.filtrosAtuais) return

        this.carregando = true
        this.fecharDetalhe()

        try {
          const { primeiroDia, dataFinal, select, receita, rede, categoria, promotor, vendedor } = this.filtrosAtuais

          const resposta = await Pedidos.showPedidosLista(
            localStorage.username, localStorage.tokencontrato,
            primeiroDia, dataFinal, select, receita, rede, categoria, promotor, vendedor,
          )

          this.pedidos = resposta.data.status ? resposta.data.pedidos : []
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, 'Erro ao buscar pedidos')
          }
        } finally {
          this.carregando = false
        }
      },

      async selecionarPedido (pedido) {
        this.pedidoSelecionado = pedido
        this.localizacaoAtual = null
        this.carregandoLocalizacao = true
        this.limparMarcador()

        try {
          const resposta = await Pedidos.showPedidoLocalizacao(
            localStorage.username, localStorage.tokencontrato,
            pedido.numpedido, pedido.nomeBd,
          )

          if (resposta.data.status) {
            this.localizacaoAtual = resposta.data
            this.exibirMarcador(resposta.data)
          } else {
            this.showSnackbar('info', 3000, resposta.data.msg || 'Localização não disponível para este pedido.')
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, 'Erro ao buscar localização do pedido')
          }
        } finally {
          this.carregandoLocalizacao = false
        }
      },

      exibirMarcador (localizacao) {
        const lat = parseFloat(localizacao.latitude)
        const lng = parseFloat(localizacao.longitude)

        if (!lat || !lng) return

        this.marker = new window.google.maps.marker.AdvancedMarkerElement({
          position: { lat, lng },
          map: this.map,
          content: this.criarElementoMarcador(),
        })

        this.map.panTo({ lat, lng })
        this.map.setZoom(15)
      },

      criarElementoMarcador () {
        const wrapper = document.createElement('div')
        wrapper.style.cssText = 'display:flex;flex-direction:column;align-items:center;'

        wrapper.innerHTML = `
          <div style="
            background:#EA4335;
            border-radius:50% 50% 50% 0;
            width:38px;
            height:38px;
            display:flex;
            align-items:center;
            justify-content:center;
            box-shadow:0 2px 6px rgba(0,0,0,0.3);
            transform:rotate(-45deg);
            border:2px solid white;
          ">
            <svg style="transform:rotate(45deg);" width="18" height="18" viewBox="0 0 24 24" fill="white">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/>
            </svg>
          </div>
        `
        return wrapper
      },

      limparMarcador () {
        if (this.marker) {
          this.marker.map = null
          this.marker = null
        }
      },

      fecharDetalhe () {
        this.pedidoSelecionado = null
        this.localizacaoAtual = null
        this.limparMarcador()
      },

      getStatusColor (status) {
        const s = String(status || '').toLowerCase().trim()

        switch (s) {
          case 'pedido a confirmar':
            return '#FFC107'
          case 'liberado':
            return '#2196F3'
          case 'separado':
          case 'em processo de separação':
            return '#FFC107'
          case 'venda':
          case 'brinde':
            return '#4CAF50'
          case 'cancelado':
            return '#D32F2F'
          default:
            return '#9E9E9E'
        }
      },

      hexToRgba (hex, opacity) {
        const r = parseInt(hex.slice(1, 3), 16)
        const g = parseInt(hex.slice(3, 5), 16)
        const b = parseInt(hex.slice(5, 7), 16)
        return `rgba(${r}, ${g}, ${b}, ${opacity})`
      },

      getAvatarBg (pedido) {
        return this.hexToRgba(this.getStatusColor(pedido.status), 0.15)
      },

      getIniciais (nome) {
        if (!nome) return '?'
        return nome.split(' ').slice(0, 2).map(p => p[0]).join('').toUpperCase()
      },

      formatarValor (valor) {
        return (valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.color = color
        this.snackbar.timeout = timeout
        this.snackbar.message = message
        this.snackbar.visible = true
      },
    },
  }
</script>

<style scoped>
  .pedido-body { display: flex; flex: 1; overflow: hidden; }
  .pedido-sidebar {
    width: 360px; min-width: 260px; display: flex; flex-direction: column;
    border-right: 1px solid rgba(0,0,0,0.08); background: #fafafa; overflow: hidden;
  }
  .pedido-sidebar__search { padding: 10px 10px 8px; border-bottom: 1px solid rgba(0,0,0,0.06); }
  .pedido-sidebar__loading { padding: 16px; display: flex; align-items: center; justify-content: center; font-size: 13px; color: #888; }
  .pedido-sidebar__lista { overflow-y: auto; flex: 1; }
  .pedido-sidebar__vazio { padding: 20px; text-align: center; font-size: 13px; color: #aaa; }

  .pedido-card {
    display: flex; align-items: center; gap: 10px; padding: 10px 14px; cursor: pointer;
    border-bottom: 0.5px solid rgba(0,0,0,0.05); transition: background 0.15s;
  }
  .pedido-card:hover { background: #f0f4f8; }
  .pedido-card--selecionado { background: #e8f0fe; }
  .pedido-card__avatar {
    width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center;
    justify-content: center; font-size: 12px; font-weight: 600; flex-shrink: 0;
  }
  .pedido-card__info { flex: 1; min-width: 0; }
  .pedido-card__nome { font-size: 13px; font-weight: 500; color: #222; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .pedido-card__sub { font-size: 11px; color: #888; margin-top: 1px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .pedido-card__data { font-size: 10px; color: #aaa; margin-top: 2px; }
  .pedido-card__dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }

  .pedido-area { flex: 1; position: relative; overflow: hidden; }
  .pedido-canvas { width: 100%; height: 100%; }

  .pedido-detalhe-card {
    position: absolute; bottom: 28px; right: 12px; width: 260px; background: white;
    border: 0.5px solid rgba(0,0,0,0.12); border-radius: 12px; z-index: 10;
    overflow: hidden; box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  }
  .pedido-detalhe-card__header { display: flex; align-items: center; gap: 10px; padding: 12px 12px 8px; border-bottom: 0.5px solid rgba(0,0,0,0.07); }
  .pedido-detalhe-card__avatar { width: 32px !important; height: 32px !important; font-size: 11px !important; }
  .pedido-detalhe-card__titulo { flex: 1; min-width: 0; }
  .pedido-detalhe-card__nome { font-size: 13px; font-weight: 600; color: #222; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .pedido-detalhe-card__sub { font-size: 11px; color: #888; margin-top: 1px; }
  .pedido-detalhe-card__loading { padding: 14px 12px; display: flex; align-items: center; font-size: 12px; color: #888; }
  .pedido-detalhe-card__body { padding: 8px 12px 12px; }

  .pedido-detalhe-row { display: flex; justify-content: space-between; align-items: center; font-size: 12px; padding: 5px 0; border-bottom: 0.5px solid rgba(0,0,0,0.04); }
  .pedido-detalhe-row:last-child { border-bottom: none; }
  .pedido-detalhe-row--destaque { background: #f9f9f9; margin: 0 -12px; padding: 5px 12px; border-radius: 0 0 8px 8px; }
  .pedido-detalhe-row__label { color: #888; flex-shrink: 0; margin-right: 8px; }
  .pedido-detalhe-row__val { color: #222; font-weight: 500; text-align: right; }
  .pedido-detalhe-row__val--aviso { color: #D32F2F; font-weight: 400; }

  .slide-up-enter-active, .slide-up-leave-active { transition: all 0.25s ease; }
  .slide-up-enter, .slide-up-leave-to { transform: translateY(12px); opacity: 0; }

  .pedido-spinner { animation: spin 1s linear infinite; }
  @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

  @media (max-width: 680px) {
    .pedido-detalhe-card { width: calc(100% - 24px); right: 12px; left: 12px; }
  }
</style>
